import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { AngularServices, getAngularService } from '../../../core';
import { useSelector } from 'react-redux';
import { selectDoctors } from '../../../../store/features/realtime/presence';
import { DoctorsDropdown } from '../doctors-dropdown';
import { useChatButton } from './useChatButton';
import './toggle-chat.scss';
export const ToggleChat = () => {
    const activeComponents = useMemo(() => getAngularService(AngularServices.ActiveComponents), []);
    const pnService = useMemo(() => getAngularService(AngularServices.Pn), []);
    const { isShowButton } = useChatButton();
    const [showDoctorsList, setShowDoctorsList] = useState(false);
    const doctors = useSelector(selectDoctors);
    const sortedDoctors = useMemo(() => {
        const uniqPnDoctors = pnService.people.getUniqDoctors();
        return doctors
            .filter(({ uuid }) => uniqPnDoctors.some(({ uuid: pnUuid }) => pnUuid === uuid))
            .sort((a, b) => {
            return a.state.username.localeCompare(b.state.username);
        });
    }, [doctors, pnService.people]);
    const toggleShowDoctorsList = useCallback(() => {
        if (doctors.length > 0) {
            setShowDoctorsList(!showDoctorsList);
        }
    }, [showDoctorsList, setShowDoctorsList, doctors]);
    const openChat = useCallback(() => {
        const uniqDoctors = pnService.people.getUniqDoctors();
        activeComponents.chat.openChat(uniqDoctors[0]);
    }, [pnService.people, activeComponents.chat]);
    const openChatWithDoctor = useCallback((doctorUuid) => {
        const pnPerson = pnService.people
            .getUniqDoctors()
            .find(({ uuid }) => uuid === doctorUuid);
        activeComponents.chat.openChat(pnPerson);
        setShowDoctorsList(false);
    }, [pnService.people, activeComponents.chat]);
    const onCloseDoctorsList = useCallback(() => {
        setShowDoctorsList(false);
    }, [setShowDoctorsList]);
    useEffect(() => {
        if (doctors.length === 0) {
            onCloseDoctorsList();
        }
    }, [doctors, onCloseDoctorsList]);
    return (isShowButton ? (<div className="doctors-list-wrap">
        <button data-testid="toggle-chat" className="waiting-room-header-chat" aria-label="chat with provider" onClick={doctors.length === 1 ? openChat : toggleShowDoctorsList}>
          <i className="icon icon-bubble"></i>
        </button>
        <DoctorsDropdown isOpen={showDoctorsList} doctors={sortedDoctors} onDoctorClick={openChatWithDoctor} onClose={onCloseDoctorsList}/>
      </div>) : null);
};
